"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUniqueFileName = generateUniqueFileName;
exports.getFilenameAndExtension = getFilenameAndExtension;
exports.getFileDisplayName = getFileDisplayName;
function generateUniqueFileName(fileName, extension, files) {
    const fileExtensionSuffix = extension ? `.${extension}` : "";
    const baseName = fileName;
    let newName = `${baseName}${fileExtensionSuffix}`;
    // Check if the file name already exists, and append a timestamp or index
    let count = 1;
    while (files.some((f) => {
        const extensionSuffix = f.extension ? `.${f.extension}` : "";
        return `${f.fileName}${extensionSuffix}` === newName;
    })) {
        newName = `${baseName} (${count})${fileExtensionSuffix}`;
        count++;
    }
    return newName;
}
function getFilenameAndExtension(fullname) {
    const extension = fullname.includes(".") ? fullname.split(".").pop() : ""; // Get the extension
    const fileName = extension
        ? fullname.slice(0, -extension.length - 1)
        : fullname; // Remove extension part if it exists
    return { fileName, extension: extension ? `${extension}` : "" };
}
function getFileDisplayName(fileName, extension) {
    const fileExtensionSuffix = extension ? `.${extension}` : "";
    const baseName = fileName;
    let newName = `${baseName}${fileExtensionSuffix}`;
    return newName;
}
